
import { Button } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import RecipeIngredientList from './RecipeIngredientList'


const RecipeDisplay = (props) => {

    const [objData, setObjData] = useState(props.obj);
    const [edit, setEdit] = useState(false);

    let nameJsx = <h3>{props.obj.name}</h3>


    const editRecipe = (newVal) => {

        if(newVal==props.obj.name) {
            return;
        }
        let newObj = { ...props.obj };
        newObj.name = newVal;
        props.editFunction(props.index, newObj);
        setEdit(false);
    }

    useEffect(()=>{
        setObjData(props.obj);
        console.log("useEffect props obj");
        console.log(props.obj);
    },[props.obj])


    const deleteRecipe = () => {
        props.deleteFunction(props.index);
    }
    

    const handleEdit = () => {
        setEdit(true);
    }
    return (
        <>
        
        <Row className="border mb-3">
            <Col xs={8}>
                <NameComponent nameVal={props.obj.name} edit={edit} handleEdit={editRecipe} />
            </Col>
            <Col xs={4}>
                <Button onClick={handleEdit} value="Rediger">Rediger</Button>
                <Button onClick={deleteRecipe} value="Slet opskrift">Slet </Button>
            </Col>

             <RecipeIngredientList isVisible={edit} recipeId={props.obj.id} />
        </Row>
        </>
        
    );

}


const NameComponent = (props) => {
    const [name, setName] = useState(props.nameVal);
    const [edit, setEdit] = useState(props.edit)

    
    useEffect(() => {
        setName(props.nameVal);
        setEdit(props.edit)
    }, [props.edit, props.nameVal])

    const updateRecipe = (val) => {
        props.handleEdit(val)
    }
    
    if(edit) {
        return <input
        defaultValue={name}
        onChange={e => setName(e.target.value)}
        onBlur={e => updateRecipe(e.target.value)}
        />
    }

    return <p>{props.nameVal}</p>
}

export default RecipeDisplay;